export default __webpack_public_path__ + "static/media/PT2.eef02b69.webp";